<h4 nz-typography class="title">{{ title | uppercase }}</h4>
<div class="user-container">
  @if (acesso.contexto(); as contexto) {
    @if (contexto.nomeUsuario || contexto.nomeUnidade) {
      @if (iniciais(contexto.nomeUsuario); as letras) {
        <span class="avatar-iniciais" aria-hidden="true">{{ letras }}</span>
      } @else {
        <nz-avatar [nzSize]="40" nzIcon="user" aria-label="Usuário"></nz-avatar>
      }
      <span class="user-reference identificacao">
        <span class="user-name">{{ contexto.nomeUsuario || 'Usuário ' + contexto.usuarioReferencia }}</span>
        <span class="user-unit">Unidade <span class="chip-unidade">{{ contexto.nomeUnidade || contexto.unidadeReferencia }}</span>
          @if (contexto.diretoriaReferencia) { · Diretoria: {{ contexto.diretoriaReferencia }} }
        </span>
      </span>
    } @else {
      <nz-avatar [nzSize]="40" nzIcon="user" aria-label="Usuário"></nz-avatar>
      <span class="user-reference">Usuário: {{ contexto.usuarioReferencia }} · Unidade: {{ contexto.unidadeReferencia }}
        @if (contexto.diretoriaReferencia) { · Diretoria: {{ contexto.diretoriaReferencia }} }
      </span>
    }
    <!-- Sair só com ícone; o rótulo fica no tooltip e, oculto, como nome acessível do link. -->
    <a class="sair" routerLink="/acesso" nz-tooltip nzTooltipTitle="Sair" nzTooltipPlacement="bottom"><span
      class="sair-icone" nz-icon nzType="logout" aria-hidden="true"></span><span class="visualmente-oculto">SAIR</span></a>
  } @else {
    <nz-avatar [nzSize]="40" nzIcon="user" aria-label="Usuário"></nz-avatar>
    @if (!naTelaDeLogin()) {
      <a nz-button nzType="link" routerLink="/acesso">ENTRAR</a>
    }
  }
</div>
